import { render, staticRenderFns } from "./ThkMaterialBoxList.vue?vue&type=template&id=3a72461d&scoped=true"
import script from "./ThkMaterialBoxList.vue?vue&type=script&lang=js"
export * from "./ThkMaterialBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a72461d",
  null
  
)

export default component.exports